import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { mediaPieGraph } from 'lib/api/media';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';

import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import CustomActiveShapePieChart from 'components/organisms/Chart/CustomActiveShapePieChart';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const StatisticsGraph = ({ params }) => {
  const { t } = useTranslation();

  const initGraphList = {
    advrtsAmtDatas: {},
    amtMediaCnts: {},
    mediaCntDatas: {},
    newMediaCnts: {},
  };
  const [graphList, setGraphList] = useState(initGraphList);
  const initLoading = {
    graph: true,
  };
  const [loading, setLoading] = useState(initLoading);
  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [params]);

  const getData = () => {
    setLoading(initLoading);
    setGraphList(initGraphList);
    mediaPieGraph()
      .then((response) => {
        const { data } = response.data;
        setGraphList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...snackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setLoading({
          ...loading,
          graph: false,
        });
      });
  };

  /**
   * 새로고침
   */
  const handleRefesh = () => {
    getData();
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
      message: '',
    });
  };

  return (
    <>
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('최근30일 매체수 그래프')}
              tooltipTitle={t('까지의 통계 그래프입니다.', {
                date: t('term', {
                  startDate: moment().add(-1, 'month').format('YYYY-MM-DD'),
                  endDate: moment().format('YYYY-MM-DD'),
                }),
              })}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
        noTopMargin={true}
      >
        <ContentsWrap loading={loading.graph} contentsCount={2}>
          <CustomActiveShapePieChart
            title={
              t('매체수') +
              ' : ' +
              numeral(graphList.mediaCntDatas.total).format('#,##0')
            }
            data={graphList.mediaCntDatas.data}
            total={graphList.mediaCntDatas.total}
            dataKey="value"
            legend
          />
          <CustomActiveShapePieChart
            title={
              t('지출금액') +
              ' : ' +
              numeral(graphList.advrtsAmtDatas.total).format('#,##0')
            }
            data={graphList.advrtsAmtDatas.data}
            total={graphList.advrtsAmtDatas.total}
            dataKey="value"
            legend
          />
          <CustomActiveShapePieChart
            title={
              t('지출금액별 매체수') +
              ' : ' +
              numeral(graphList.amtMediaCnts.total).format('#,##0')
            }
            data={graphList.amtMediaCnts.data}
            total={graphList.amtMediaCnts.total}
            dataKey="value"
            legend
          />
          <CustomActiveShapePieChart
            title={
              t('최근 30일 신규 매체수') +
              ' : ' +
              numeral(graphList.newMediaCnts.total).format('#,##0')
            }
            data={graphList.newMediaCnts.data}
            total={graphList.newMediaCnts.total}
            dataKey="value"
            legend
          />
        </ContentsWrap>
      </SwitchingArea>
      <SnackbarWrap
        open={snackbar.open}
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleSnackBarClose}
      />
    </>
  );
};

export default StatisticsGraph;
